<template>
    <div class="detail" v-wechat-title='$route.meta.title'>
        <van-swipe  indicator-color="#fff" :show-indicators="false" :loop='false'  class="top_swipe" @change="onChange">
            <van-swipe-item v-for="(li, index) in list" :key="index" class="swipe_item">
                <detailswipe :lis = 'li' :index="index" :current="current"></detailswipe>
                <div class="bottom">
                   <div class="detail_tips">{{li.SpecilComment}}</div>
                </div>
            </van-swipe-item>
        </van-swipe>
        <div class="detail_page"><span class="detail_currentpage">{{ currentPage }}</span>/<span class="total">{{total}}</span></div>
    </div>
</template>

<script>
import detailswipe from './detailswipe'
export default {
    data() {
        return {
            linkid:'',
            linktitle:'',
            current: 0,
            currentPage:'01',
            total:"01",
            //swipeheight: 1125,
            images: [],
            list: null
        }
    },
    components:{
        detailswipe
    },
    methods: {
        onChange(index) {
            this.current = index;
            this.currentPage = (index+1)<=9? '0' + (index+1): ''+ (index+1)
        },
        getswipelist(){
            this.$http({
                method: 'get',
                url: '/infodetail',
                params: {
                  groupid: this.$route.query.id
                },
            })
            .then((res) => {
              if (res['data']['Code'] === 0) {
                 if(res['data']["Data"]&&res['data']["Data"].length>0){
                   this.list = res['data']["Data"]
                   this.total = res['data']['Count']<10?'0' + res['data']['Count']: ''+ res['data']['Count']
                 }
              } else {
                this.$toast(res['data']["Message"])
              }
            })
        }

    },
    beforeCreate () {
        document.title =this.$route.query.title
    },
    mounted(){
      this.linkid = this.$route.query.id;
      this.linktitle = this.$route.query.title
      this.getswipelist()
    }

}
</script>
<style scoped lang="scss">
.detail{
    height: 100%;
    display: flex;
    flex-direction: column;

    .swipe_item{
        // display: flex;
        .detail_swiper{
            flex: 1;
        }
    }
    .detail_page{
        position: fixed;
        bottom: 1rem;
        right: 1.5rem;
        font-size: 0.75rem;
        letter-spacing: 0;
        text-align: center;
        line-height: 1;

    }
    .bottom{
            position: absolute;
           width: 100%;
            left: 0;
            bottom: 0;
            padding: 0 1.5rem 1rem;
            box-sizing: border-box;
            .detail_tips{
                float: left;
                font-size: 0.75rem;
                letter-spacing: 0;
                line-height: 1;
            }
        }
}
.top_swipe{
    flex:26rem;

}
</style>




// WEBPACK FOOTER //
// src/components/detail.vue